export default "__VITE_ASSET__1feb9b6e__"